import React from 'react';
import { FaShieldAlt, FaEnvelope, FaLock, FaShareAlt, FaUserSecret, FaFileContract } from 'react-icons/fa';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <img src="/logo-icon.png" alt="Donor Dispatch" className="h-12 mx-auto mb-4" />
        </div>
        <div className="card p-6 sm:p-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-navy-100">
              <FaShieldAlt className="text-xl text-navy-600" />
            </div>
            <h1 className="text-2xl sm:text-3xl font-bold text-navy-800">Privacy Policy</h1>
          </div>

          <p className="text-gray-400 text-sm mb-8 border-b border-gray-100 pb-4">Last Updated: March 2026</p>

          <div className="space-y-5">
            {[
              { icon: FaFileContract, title: 'Introduction', text: 'Thrift Solutions LLC operates the DonorDispatch mobile application. This Privacy Policy explains how we collect, use, and protect information when you use the app. We are committed to ensuring your privacy and maintaining transparency about our data practices.' },
              { icon: FaUserSecret, title: 'Information We Collect', text: 'We collect contact information (such as name, email address, and phone number), pickup request details (including address and donation items), and optional operational data to enhance your experience. This information is necessary to facilitate donation pickups and communicate with you about your donations.' },
              { icon: FaLock, title: 'How We Use Information', text: 'The information we collect is used to schedule and coordinate donation pickups, communicate with donors about their donation status, improve app functionality and user experience, and send important updates about our services. We may also use aggregated data for analytical purposes to better understand how our platform is used.' },
              { icon: FaShareAlt, title: 'Data Sharing', text: 'We do not sell personal information to third parties. Your data is only shared as necessary to fulfill donation pickups (such as providing your address to drivers) and improve our services. We may share anonymized data with partner organizations for research and reporting purposes, but this data cannot be used to identify you personally.' },
              { icon: FaLock, title: 'Data Security', text: 'We implement reasonable safeguards including encryption, secure servers, and access controls to protect your personal information from unauthorized access, disclosure, or destruction. Our team regularly reviews and updates our security practices to maintain the highest standards of data protection.' },
              { icon: FaEnvelope, title: 'Your Choices', text: null },
              { icon: FaEnvelope, title: 'Contact Us', text: null },
            ].map((section, i) => {
              if (section.title === 'Your Choices') {
                return (
                  <div key={i} className="bg-gray-50 p-5 rounded-lg border border-gray-100 hover:shadow-sm transition-shadow">
                    <h2 className="text-lg font-semibold mb-2 text-navy-700 flex items-center gap-2">
                      <section.icon className="text-brand-orange" />
                      {section.title}
                    </h2>
                    <p className="text-gray-600 leading-relaxed text-sm">
                      You have the right to access, correct, or delete your personal information at any time. You may
                      request deletion of your data by contacting us at{' '}
                      <a href="mailto:info@donordispatch.com" className="text-brand-navy font-medium hover:underline">
                        info@donordispatch.com
                      </a>. We will respond to your request within a reasonable timeframe and confirm when your data
                      has been removed from our systems.
                    </p>
                  </div>
                );
              }
              if (section.title === 'Contact Us') {
                return (
                  <div key={i} className="bg-gray-50 p-5 rounded-lg border border-gray-100 hover:shadow-sm transition-shadow">
                    <h2 className="text-lg font-semibold mb-2 text-navy-700 flex items-center gap-2">
                      <section.icon className="text-brand-orange" />
                      {section.title}
                    </h2>
                    <p className="text-gray-600 leading-relaxed text-sm mb-3">
                      If you have any questions, concerns, or requests regarding this Privacy Policy or our data
                      practices, please don't hesitate to contact us:
                    </p>
                    <div className="bg-white p-4 rounded-lg border border-gray-100">
                      <p className="text-gray-700 font-semibold text-sm">Thrift Solutions LLC</p>
                      <a
                        href="mailto:info@donordispatch.com"
                        className="text-brand-navy font-medium hover:underline inline-flex items-center gap-1 mt-2 text-sm"
                      >
                        <FaEnvelope className="text-xs" />
                        info@donordispatch.com
                      </a>
                    </div>
                  </div>
                );
              }
              return (
                <div key={i} className="bg-gray-50 p-5 rounded-lg border border-gray-100 hover:shadow-sm transition-shadow">
                  <h2 className="text-lg font-semibold mb-2 text-navy-700 flex items-center gap-2">
                    <section.icon className="text-brand-orange" />
                    {section.title}
                  </h2>
                  <p className="text-gray-600 leading-relaxed text-sm">{section.text}</p>
                </div>
              );
            })}
          </div>

          <div className="mt-8 pt-6 border-t border-gray-100">
            <p className="text-xs text-gray-400 text-center">
              By using DonorDispatch, you acknowledge that you have read and understood this Privacy Policy
              and agree to its terms. This policy may be updated periodically, and we will notify you of any
              material changes.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
